import { useParams } from "react-router-dom";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { useGetSchoolLmsConnectionsQuery } from "../../../generated/graphql";
import { useRequestError } from "../../../hooks";
import { ErrorMessageSnackbar } from "../../shared/ErrorMessageSnackbar";
import { LoadingProgress } from "../../shared/LoadingProgress";
import { formatKyivDate } from "../../shared/Utils/DateOperations/formatKyivDate";
import {
  LMS_CONNECTION_COLUMNS,
  LMS_CONNECTIONS_EMPTY,
  LMS_CONNECTIONS_ERROR,
  LmsConnectionColumnId,
} from "./constants";

const MessageRow = ({ text }: { text: string }) => (
  <TableRow>
    <TableCell colSpan={LMS_CONNECTION_COLUMNS.length} align="center">
      {text}
    </TableCell>
  </TableRow>
);

// AT2-20376: the school page's "LMS ІНТЕГРАЦІЇ" tab — every LMS connection this school has set up,
// launched or not (empty dates = settings saved, nobody has come in from that LMS yet).
export const LmsConnections = () => {
  const { schoolId } = useParams<{ schoolId: string }>();

  const { data, loading, error } = useGetSchoolLmsConnectionsQuery({
    variables: { schoolId },
    fetchPolicy: "cache-and-network",
  });
  const { requestError, setRequestError } = useRequestError(
    error,
    LMS_CONNECTIONS_ERROR
  );

  const rows = data?.getSchoolLmsConnections || [];

  if (loading && !data) {
    return <LoadingProgress />;
  }

  return (
    <>
      <Paper>
        <TableContainer>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {LMS_CONNECTION_COLUMNS.map(({ id, label }) => (
                  <TableCell key={id} align="center">
                    {label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {error && !data ? (
                <MessageRow text={LMS_CONNECTIONS_ERROR} />
              ) : rows.length === 0 ? (
                <MessageRow text={LMS_CONNECTIONS_EMPTY} />
              ) : (
                rows.map((row) => (
                  <TableRow key={row.lmsSchoolMappingId} hover>
                    {LMS_CONNECTION_COLUMNS.map(({ id }) => (
                      <TableCell key={id} align="center">
                        {id === LmsConnectionColumnId.FirstLaunchAt ||
                        id === LmsConnectionColumnId.LastLaunchAt
                          ? formatKyivDate(row[id])
                          : row[id]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <ErrorMessageSnackbar
        open={requestError}
        message={LMS_CONNECTIONS_ERROR}
        closeHandler={() => setRequestError(false)}
      />
    </>
  );
};
